import type { Release } from './types'

export * from './types'

const modules = import.meta.glob<{ default: Release }>('./releases/*.ts', { eager: true })

/** Every release, newest first. */
export const RELEASES: Release[] = Object.values(modules)
  .map(m => m.default)
  .sort((a, b) => (a.date === b.date ? b.version.localeCompare(a.version, undefined, { numeric: true }) : b.date.localeCompare(a.date)))
